export default __webpack_public_path__ + "images/cbc7ffbe6d0b73b738782321c8f2bea5-tennis.png";